import React, { useEffect } from "react";
import TawkTo from "tawkto-react";
import { Col, Container, Row } from "react-bootstrap";

import Logo from "../images/logo.png";
// import AdsBg from '../images/footer/ads-bg.png';
import Advertise from "../images/advertise/CoreDaoOpti.gif";

import SocialIcon1 from "../images/footer/telegram.svg";
import SocialIcon2 from "../images/footer/twitter.svg";
import SocialIcon3 from "../images/footer/social-2.svg";
import SocialIcon4 from "../images/footer/mintme-4.svg";
import { Link } from "gatsby";
import { Script } from "gatsby"
import "../styles/custom.css"

const Footer = ({ siteTitle, header }) => {
  useEffect(() => {
    var tawk = new TawkTo("62c7cd8db0d10b6f3e7b61d0", "1g7e7lsdp", 1);

    tawk.onStatusChange(status => {
      // console.log(status)
    });
  }, []);
  return (
    <>
      <Container>
        <div className="ads-card d-none mt-5 text-center">
          {/* <img src={AdsBg} className="ads-card-bg" alt="AdsBg" /> */}
          <h3>Ads Space for Leasing!</h3>
          <p>Have you found the right place for your ads yet?</p>
          <Link to="/" className="btn">
            Find out more!
          </Link>
        </div>
        <div className="mt-5 text-center">
          <a target="_blank" rel="noreferrer" href="https://t.me/hedgepay_ed">
            <img src={Advertise} className="img-fluid rounded-10" alt="advertise" />
          </a>
          <p className="mt-2 mb-0">
            <a href="https://t.me/hedgepay" target="_blank" rel="noreferrer">
              Advertise here? Contact us
            </a>
          </p>
        </div>
      </Container>

      <footer className="footer">
        <Container>
          <div className="footer-inner mt-5">
            <Row className="justify-content-between">
              <Col md={4} className="mb-md-0 mb-5">
                <img src={Logo} alt="HedgePay Crypto Defi Logo" />
                <h5>HedgePay</h5>
                <p className="mb-4">
                  Leading the way in providing the highest quality crypto services while improving stability and
                  security for our holders.
                </p>

                <div className="d-flex footer-social align-items-center">
                  <a href="https://t.me/hedgepay" rel="noreferrer" target="_blank" className="mr-1">
                    <img src={SocialIcon1} className="mb-0" alt="icon" />
                  </a>
                  <a href="https://twitter.com/HedgePay_" rel="noreferrer" target="_blank" className="mr-1">
                    <img src={SocialIcon2} className="mb-0" alt="icon" />
                  </a>
                  <a href="https://linktr.ee/hedgepay" rel="noreferrer" target="_blank">
                    <img src={SocialIcon3} className="mb-0" alt="icon" />
                  </a>
                  <a href="https://www.mintme.com/token/HedgePay" rel="noreferrer" target="_blank" className="mr-1">
                  <img src={SocialIcon4} className="mb-0" alt="icon" />
                  </a>
                </div>
              </Col>
              <Col md={8}>
                <Row>
                  <Col sm={3} xs={6} className="mb-sm-0 mb-4">
                    <h6>Company</h6>
                    <ul>
                      <li>
                        <Link to="/rewards">HedgePay Rewards</Link>
                      </li>
                      <li>
                        <Link to="/exchange">Buy HedgePay</Link>{" "}
                      </li>
                      <li>
                        <Link to="/transfer">Transfer Gateway</Link>
                      </li>
                      <li>
                        <Link to="/docs/about">About Us</Link>
                      </li>
                      <li>
                        <Link to="/docs/branding">Branding</Link>
                      </li>
                    </ul>
                  </Col>
                  <Col sm={3} xs={6} className="mb-sm-0 mb-4">
                    <h6>Products</h6>
                    <ul>
                      <li>
                        <Link to="/products">E-Commerce</Link>
                      </li>
                      <li>
                        <Link to="/vaults">Staking as Service</Link>{" "}
                      </li>
                      <li>
                        <Link to="/hpad">Launchpad</Link>
                      </li>
                      <li>
                        <Link to="/lock">Liquidity Locker</Link>
                      </li>
                      <li>
                        <Link to="/docs/faq/mm">Market Making</Link>
                      </li>
                      <li>
                        <Link to="/docs/faq/leaderboard">Audit & KYC</Link>
                      </li>
                      <li>
                        <Link to="/docs/faq/hedgetalk">HedgeTalk</Link>
                      </li>
                      <li>
                        <Link to="/docs/faq/leaderboard">Leaderboard</Link>
                      </li>
                    </ul>
                  </Col>
                  <Col sm={3} xs={6} className="mb-sm-0 mb-4">
                    <h6>Resources</h6>
                    <ul>
                      <li>
                        <Link to="/connect-with-us">Connect With Us</Link>
                      </li>
                      <li>
                        <Link to="/team">Meet the Team</Link>
                      </li>
                      <li>
                        <a
                          href="https://bscscan.com/address/0xc75aa1fa199eac5adabc832ea4522cff6dfd521a/"
                          rel="noreferrer"
                          target="_blank"
                        >
                          Smart Contract
                        </a>
                      </li>
                      <li>
                        <Link to="/whitepaper">Whitepaper</Link>{" "}
                      </li>
                      <li>
                        <a
                          href="https://docs.google.com/spreadsheets/d/1SDuuuKh0S66ILGK7CU4933En7n0yvfoV/edit#gid=1899305105"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Partners
                        </a>
                      </li>
                      <li>
                        <a href="/docs">Docs</a>
                      </li>
                    </ul>
                  </Col>
                  <Col sm={3} xs={6} className="mb-sm-0 mb-4">
                    <h6>Support</h6>
                    <ul>
                      <li>
                        <Link to="/help">Help Center</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/request">Request Form</Link>
                      </li>
                      <li>
                        <a href="https://discord.gg/SDnQJSFzPm" rel="noreferrer" target="_blank">
                          Technical Support
                        </a>
                      </li>
                      <li>
                        <Link to="/terms">Term of service</Link>
                      </li>
                      <li>
                        <Link to="/privacy">Privacy policies</Link>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Col>
              <Col md={8}>
                <p style={{ marginTop: "3rem" }}>
                  <span style={{ fontSize: "0.95em" }}>
                    <sup>1</sup> BUSD rewards is a term utilized by HedgePay to refer to BUSD rewards generated from the
                    HedgeFi Algorithm, meant to be collected monthly by contributor. This in no way indicates any right
                    or responsibility from any party and hedgepay nor any financial implications, ownership, right, or
                    responsibility.
                  </span>
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
